import _ from 'lodash';
import Alpine from "alpinejs";

window._ = _;

window.Alpine = Alpine;

window.addEventListener("DOMContentLoaded", () => {
    Alpine.start();
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });


function dispactchEvent(target, event, detail) {

    const dispatch = new CustomEvent(event, {
        detail,
        bubbles: true,
        cancelable: true,
    });
    if (target.toString() === target) {
        target = document.querySelector(target);
    }
    if (target) {
        target.dispatchEvent(dispatch);
    }
    return dispatch;
}

document.addEventListener("click", function(event) {
    const node = event.target.closest("a") || event.target;
    const url = node.getAttribute("href") || "";
    if (!url.startsWith("#")) {
        return true;
    }
    const result = dispactchEvent(node, url.substring(1), node.dataset);
    if (result.defaultPrevented) {
        event.preventDefault();
        event.stopPropagation();
    } else {
        let result2 = dispactchEvent(url, "trigger", node.dataset);
        if (result2.defaultPrevented) {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    return result;
});

// $(document.body).on("click", "a", function ($event) {
//     const url = $(node).attr("href") || "";
//
// });
